import React, {Component} from 'react';

export default class AccordionContent extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let accordionContent;

        if(this.props.content) {
            accordionContent = this.props.content;
        } else {
            accordionContent = (
                <div className="loader--full-screen">
                    <div className="loader__icon"/>
                </div>
            );
        }

        return (
            <div
                id={"accordion-content-" + this.props.index}
                role="region"
                aria-labelledby={"accordion-header-" + this.props.index}
                className="accordion__content accordion__content--padded"
                hidden={!this.props.isActive}>
                {accordionContent}
            </div>
        );
    }
}